var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 11.8l5.3-5.4a.8.8 0 000-1.2.8.8 0 00-1 0L12 10.7 6.7 5.2a.8.8 0 00-1.1 0 .8.8 0 000 1.2l5.3 5.4-5.7 5.8a.8.8 0 000 1.2.8.8 0 001.1 0L12 13l5.7 5.8a.8.8 0 001 0 .8.8 0 000-1.2l-5.6-5.8z",
    fill: "#666666",
    stroke: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.c92fbc500109345fdf290264346f6b5e.svg";
export { ForwardRef as ReactComponent };